import {
  AddIcon,
  Asset,
  AssetProps,
  Button,
  InfoFilledIcon,
  NoIcon,
  ShieldIcon,
  SupervisedUserCircleIcon,
  VehicleOutlineIcon,
  PricetagIcon,
} from '@clearcover/atlas';
import classNames from 'classnames';
import React, { FC } from 'react';
import styles from './styles.module.css';

import { VersionedObjectDiff } from '@clearcover/core-app-types';

const icons: Record<string, AssetProps['icon']> = {
  coverage: ShieldIcon,
  driver: SupervisedUserCircleIcon,
  insurableItemRelationship: SupervisedUserCircleIcon,
  vehicle: VehicleOutlineIcon,
  discount: PricetagIcon,
  address: SupervisedUserCircleIcon,
  ADDED: AddIcon,
  DELETED: NoIcon,
  UPDATED: InfoFilledIcon,
};

export const changeTypes: Record<VersionedObjectDiff<any>['type'], string> = {
  ADDED: 'Added',
  DELETED: 'Removed',
  UPDATED: 'Change',
};

export const getUnifiedDiffType = (
  diffs: Array<VersionedObjectDiff<any>>
): VersionedObjectDiff<any>['type'] => {
  const allTypes = Array.from(new Set(diffs.map(it => it.type)));
  return allTypes.length === 1 ? allTypes[0] : 'UPDATED';
};

export const joinNonEmpty = (...arr: Array<string | number | undefined>) =>
  arr.filter(it => !!it?.toString().trim()).join(' ');

export const getCurrentData = <T,>(diff: VersionedObjectDiff<T>): T =>
  diff.type === 'DELETED' ? diff.old : diff.new;

export type PolicyChangeCardProps = {
  'data-testid': string;
  type:
    | 'coverage'
    | 'driver'
    | 'vehicle'
    | 'discount'
    | 'address'
    | 'insurableItemRelationship';
  action: 'ADDED' | 'DELETED' | 'UPDATED';
  title: string;
  value: string;
  selected: boolean;
  onClick: () => void;
};

export const PolicyChangeCard: FC<PolicyChangeCardProps> = ({
  'data-testid': dataTestId,
  type,
  action,
  title,
  value,
  selected,
  onClick,
}) => {
  return (
    <Button
      variant="secondary"
      className={classNames(
        styles.card,
        styles[type],
        selected && styles.selected
      )}
      onClick={onClick}
      data-testid={dataTestId}
    >
      <div className={styles.title}>
        <div className={styles.iconContainer}>
          <Asset
            icon={icons[type]}
            description={`${type} icon`}
            height={24}
            width={24}
            className={styles.icon}
          />
          <Asset
            icon={icons[action]}
            description={`${type} icon`}
            height={20}
            width={20}
            className={classNames(styles.overlayIcon, styles[action])}
          />
        </div>
        <span data-testid={`${dataTestId}-title`}>{title}</span>
      </div>
      <div data-testid={`${dataTestId}-value`} className={styles.cardDetails}>
        {value}
      </div>
    </Button>
  );
};
